import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// import _data from '../../../mock_data/data';
import _data from "../../mock_data/data.json";

// Common Header Components
import MainMenu from "./partials/main-menu";
import CartMenu from "./partials/cart-menu";
import CategoryMenu from "./partials/category-menu";

import LoginModal from "../features/modal/login-modal";

import { showModal } from "../../actions";

import { getAllCategories } from "../../actions/categoryActions";
import { getWishList, clearWishList } from "../../actions/wishlistActions";
import { logoutUser } from "../../actions/userActions";
import {
  getCartList,
  getCartListOrders,
  clearCashList,
} from "../../actions/cartlistActions";

import { addSearchKeywordToFilters } from "../../actions/variantFilterActions";
import { getAllVariantsWithFilters } from "../../actions/variantActions";

import "./newstyle.css";
import axios from "axios";
import Search from "./Search";

// const imageSrc = process.env.REACT_APP_API_URL + "/uploads/variant_images/";

function Header(props) {
  const { container = "container" } = props;

  const [inav, setInav] = useState(false);

  const changeVisibilite = () => {
    if (window.scrollY < 300) {
      setInav(false);
    } else if (window.scrollY >= 300) {
      setInav(true);
    }
  };

  window.addEventListener("scroll", changeVisibilite);

  let categories = props.categories;
  let isLogged = props.isLogged;
  let user = props.user;

  let wishlistTotal = props.wishlistTotal;

  function openLoginModal(e) {
    props.showModal("login");
    e.preventDefault();
  }

  useEffect(() => {
    // console.log("produits:"+products)

    if (isLogged) {
      props.getWishList();
      props.getCartList();
      props.getCartListOrders();
    }
  }, [isLogged]);

  function logoutUser(e) {
    props.clearCashList();
    props.clearWishList();
    props.logoutUser();
    e.preventDefault();
  }

  return (
    <header className="header header-14">
      <div className="header-top">
        <div className={container}>
          <div className="header-left">
            <a href="tel:#">
              <i className="icon-phone"></i>Service Clients : 06 00 661 - 799
            </a>
          </div>

          {isLogged ? (
            <div className="header-center" style={{ marginRight: "20px" }}>
              <Link to="/shop/dashboard">
                <i className="icon-user"></i>Bienvenue {user.firstName}{" "}
                {user.lastName}
              </Link>
            </div>
          ) : (
            <div className="header-center" style={{ marginRight: "20px" }}>
              <span></span>
            </div>
          )}

          <div className="header-right">
            <ul className="">
              {isLogged ? (
                <li className="font-weight-bolder btn btn-primary text-white logout">
                  <Link
                    to="#signup-modal"
                    data-toggle="modal"
                    onClick={logoutUser}
                  >
                    Se Déconnecter
                  </Link>
                </li>
              ) : (
                <li className="font-weight-bolder btn btn-primary text-white login">
                  <Link
                    to="#signin-modal"
                    data-toggle="modal"
                    onClick={openLoginModal}
                  >
                    Se Connecter
                  </Link>
                </li>
              )}
              {/* <li>
                <Link to="#">Se déconnecter mobile</Link>
                <ul className="menus">
                  <li>
                    <div className="header-dropdown"></div>
                  </li>
                  
                </ul>
              </li> */}
            </ul>
          </div>
        </div>
      </div>
      <div className="header-middle">
        <div className={container}>
          <div className="row">
            <div className="col-auto col-lg-3 col-xl-3 col-xxl-2">
              <button className="mobile-menu-toggler">
                <span className="sr-only">Toggle mobile menu</span>
                <i className="icon-bars"></i>
              </button>
              <Link
                to={`${process.env.REACT_APP_PUBLIC_URL}/`}
                className="logo"
                style={{
                  marginTop: "0.5rem",
                  marginBottom: "0.95rem",
                  marginLeft: "10.5rem",
                }}
              >
                <img
                  src={`${process.env.REACT_APP_PUBLIC_URL}/assets/images/logo11and11.png`}
                  alt="11-11 fresh"
                  width="105"
                  height="25"
                />
              </Link>
            </div>
            <div className="col col-lg-9 col-xl-9 col-xxl-10 header-middle-right">
              <div className="row">
                <div className="col-lg-8 col-xxl-4-5col search-bar">
                  <div className="header-search header-search-extended header-search-visible header-search-no-radius ">
                    {/* <Link
                      to="/shop/sidebar/list"
                      className="search-toggle"
                      role="button"
                    >
                      <i className="icon-search"></i>
                    </Link> */}

                    <Search />
                  </div>
                </div>
                <div className="col-lg-4 col-xxl-5col d-flex justify-content-end align-items-center">
                  <div className="header-dropdown-link">
                    {isLogged ? (
                      <Link
                        to={`${process.env.REACT_APP_PUBLIC_URL}/shop/dashboard`}
                        className="wishlist-link"
                      >
                        <i className="icon-user"></i>
                        <span className="wishlist-txt">Account</span>
                      </Link>
                    ) : (
                      ""
                    )}
                    <Link
                      to={`${process.env.REACT_APP_PUBLIC_URL}/shop/wishlist`}
                      className="wishlist-link"
                    >
                      <i className="icon-heart-o"></i>
                      <span className="wishlist-count">{wishlistTotal}</span>
                      <span className="wishlist-txt">Favorits</span>
                    </Link>
                    <CartMenu innav={false} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="header-bottom sticky-header"
        style={{ backgroundColor: "#0a68a0" }}
      >
        <div className={container}>
          <div className="row">
            <div className="col-auto col-lg-3 col-xl-3 col-xxl-2 header-left">
              <CategoryMenu />
            </div>

            <div className="col col-lg-6 col-xl-6 col-xxl-8 header-center">
              <MainMenu />
            </div>

            <div
              id="navitem"
              className={
                inav
                  ? "col col-lg-3 col-xl-3 col-xxl-2 header-right active"
                  : "col col-lg-3 col-xl-3 col-xxl-2 header-right"
              }
            >
              <Link
                to={`${process.env.REACT_APP_PUBLIC_URL}/shop/wishlist`}
                className="wishlist-link text-white"
              >
                <i className="icon-heart-o text-white"></i>
                <span className="wishlist-count">{wishlistTotal}</span>
                <span className="wishlist-txt text-white">Favorits</span>
              </Link>
              <div>
                <CartMenu innav={true} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <LoginModal />
    </header>
  );
}

function mapStateToProps(state) {
  return {
    categories: state.categories.categories ? state.categories.categories : [],
    slides: state.slides.slides ? state.slides.slides : [],
    wishlistTotal: state.userwishlist.total ? state.userwishlist.total : 0,
    wishlist: state.wishlist.list,
    isLogged: state.user.isLogged ? state.user.isLogged : false,
    user: state.user.user ? state.user.user : {},
  };
}

export default connect(mapStateToProps, {
  getCartListOrders,
  addSearchKeywordToFilters,
  getAllVariantsWithFilters,
  clearCashList,
  clearWishList,
  getCartList,
  showModal,
  getAllCategories,
  getWishList,
  logoutUser,
})(Header);
